import { styled } from "../../../stitches.config";

import { DialogDescription as DialogDescriptionBase } from "../../../components/lib/Dialog";

export * from "../../../components/lib/Dialog";

export const DialogDescription = styled(DialogDescriptionBase, {
  backgroundColor: "inherit",
});
